import { render, staticRenderFns } from "./FullWidthText.vue?vue&type=template&id=5118b836&scoped=true&"
import script from "./FullWidthText.vue?vue&type=script&lang=ts&"
export * from "./FullWidthText.vue?vue&type=script&lang=ts&"
import style0 from "./FullWidthText.vue?vue&type=style&index=0&id=5118b836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5118b836",
  null
  
)

export default component.exports